import { useId } from "react";
import type { ProductVendor } from "@models/product";
import { currencyFormatter } from "@utils/formatter";
import { formatStock } from "../../_helpers/formatStock";

interface VendorOfferingsProps {
    /** The product's own active rows (activeBaseOfferings). */
    offerings: ProductVendor[];
    /** The product is made of variants, each priced by its own vendors. */
    hasVariants: boolean;
}

// Read-only (ruling I2): vendor prices and stock come from the vendors, and
// there is no admin screen that writes them (2026-10-16 ruling).
export const VendorOfferings = ({
    offerings,
    hasVariants,
}: VendorOfferingsProps) => {
    const headingId = useId();

    return (
        <div>
            <span id={headingId} className="font-semibold block mb-1">
                Vendor offerings
            </span>
            {offerings.length > 0 && (
                <table
                    className="table table-xs"
                    aria-labelledby={headingId}
                >
                    <thead>
                        <tr className="text-neutral">
                            <th>Vendor</th>
                            <th className="text-right">Price</th>
                            <th className="text-right">Stock</th>
                        </tr>
                    </thead>
                    <tbody>
                        {offerings.map((offering) => (
                            <tr key={offering.id}>
                                <td>{offering.vendorName}</td>
                                <td className="text-right">
                                    {currencyFormatter.format(offering.price)}
                                </td>
                                <td className="text-right">
                                    {formatStock(offering.availableQuantity)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            {/* A variant's own rows belong to the Edit page's variants list
                (a later batch), so only the note is shown here. */}
            {hasVariants && (
                <p className="text-sm text-gray-500">Priced per variant.</p>
            )}
            {offerings.length === 0 && !hasVariants && (
                <p className="text-sm text-gray-500">No vendor offerings.</p>
            )}
        </div>
    );
};
